module.exports = __webpack_public_path__ + "img/santa-hat.9e75867a.svg";